/**
 * Return, whether the user is on the login page.
 * @param pathname The pathname to check.
 */
const isOnLogin = (pathname) => pathname.includes('login');

/**
 * Return, whether the user is on the logout page.
 * @param pathname The pathname to check.
 */
const isOnLogout = (pathname) => pathname.includes('logout');

/**
 * Return, whether the user is on the join page.
 * @param pathname The pathname to check.
 */
const isOnJoin = (pathname) => pathname.includes('join');

/**
 * Return, whether the user is on the root page.
 * @param pathname The pathname to check.
 */
const isOnRoot = (pathname) => pathname === '/';

export { isOnLogin, isOnLogout, isOnJoin, isOnRoot };
